import { makeStyles } from "@mui/styles";
import logo from "../../../assets/images/login/xnuup_main_logo_white.png";
import iconQuoteSelected from "../../../assets/images/login/icon-quote-selected.png";
import iconQuoteNotSelected from "../../../assets/images/login/icon-quote-not-selected.png";
import styled from "styled-components";

const drawerWidth = 170;

export const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: 36,
	},
	hide: {
		display: "none",
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap",
		"& .MuiDrawer-paper": {
			boxShadow: "4px 0px 12px #0000000D",
		},
		"& .MuiDrawer-paperAnchorDockedLeft": {
			borderRight: "none",
		},
		"& .MuiDrawer-paper::-webkit-scrollbar": {
			width: 0,
		},
	},
	drawerOpen: {
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerClose: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		overflowX: "hidden",
		width: 43,
		[theme.breakpoints.up("sm")]: {
			width: 43,
		},
	},
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		// ...theme.mixins.toolbar
		minHeight: 56,
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		backgroundColor: "#f4f5fd",
		height: "100vh",
	},
	logo: {
		display: "flex",
		alignItems: "center",
		backgroundImage: `url(${logo})`,
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		height: "30px",
		width: "115px",
		"@media (max-width: 425px)": {
			height: "20px",
			width: "100px",
		},
	},
	containerActions: {
		display: "flex",
		alignItems: "center",
		gap: "0.4rem",
	},
	containerAppBar: {
		backgroundColor: theme.headerColor,
		height: 58,
		color: theme.palette.common.white,
		boxShadow: "4px 0px 12px #EAECEF",
	},
	iconMenu: { color: "#6C7882", cursor: "pointer", marginLeft: 5 },
	iconQuoteSelected: {
		backgroundImage: `url(${iconQuoteSelected})`,
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		height: "19px",
		width: "19px",
	},
	iconQuoteNotSelected: {
		backgroundImage: `url(${iconQuoteNotSelected})`,
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		height: "19px",
		width: "19px",
		marginRight: "-4px",
	},
}));

export const ContainerDataMenu = styled.div`
	display: flex;
	width: 100%;

	align-items: center;
	justify-content: space-between;
`;

export const ContainerOrderIcon = styled.div`
	margin-left: -1px;
	margin-right: -2px;
`;

export const ButtonLink = styled.button`
	border: unset;
	outline: none !important;
	background: unset;
	padding: unset;
`;

export const AreaLogo = styled.div`
	display: flex;
	align-items: center;
	height: 30px;
	width: 115px;

	img {
		max-width: 100%;
		max-height: 100%;
		width: auto;
		height: auto;
		object-fit: contain;
	}

	@media (max-width: 425px) {
		height: 20px;
		width: 100px;
	}
`;
